import http from './http'
//所有分类
export function getAll(){
    return http({
        url:'/get_all_type',
        method:'post'
    })
}
//获取收录列表
export function getLb(data){
    return http({
        url:'/get_services_pt',
        method:'post',
        data
    })
}
//获取广告列表
export function getGgLb(){
    return http({
        url:'/get_ad',
        method:'post'
    })
}

//收录申请
export function slsq(data){
    return http({
        url:'/sq_sl',
        method:'post',
        data
    })
}

//提交建议
export function tjjj(data){
    return http({
        url:'/tj_suggestion',
        method:'post',
        data
    })
}

//收录验证
export function slyz(data){ 
    return http({
        url:'/pt_yz',
        method:'post',
        data
    })
}

//收录，访问数量
export function webNum(data){ 
    return http({
        url:'/get_tongji',
        method:'post',
        data
    })
}

//消息列表
export function getNotice(data){ 
    return http({
        url:'/list_notices',
        method:'post',
        data
    })
}
// 记录点击历史
export function recordHistory(data){
    return http({
        url:'/records_history',
        method:'post',
        data
    })
}
// 记录广告点击
export function recordAd(data){
    return http({
        url:'/records_ad',
        method:'post',
        data
    })
}
// ========== 新增：认领/提交需求相关接口 ==========

// 1. 获取图形验证码
export function getCaptcha(){
    return http({
        url:'/captcha',
        method:'post'
    })
}

// 2. 验证图形验证码
export function verifyCaptcha(data){
    return http({
        url:'/verifyCaptcha',
        method:'post',
        data
    })
}

// 3. 获取短信验证码
export function getPhoneCode(data){
    return http({
        url:'/getPhoneCode',
        method:'post',
        data
    })
}

// 4. 提交预约/需求
export function webYuyueService(data){
    return http({
        url:'/web_yuyue_service',
        method:'post',
        data
    })
}

// 5. 提交认领
export function submitClaim(data){
    return http({
        url:'/web_claim',
        method:'post',
        data
    })
}
// 获取通知详情
export function getNoticeDetail(data){
    return http({
        url:'/get_notices',
        method:'post',
        data
    })
}